import React from 'react'
import { useMap } from 'react-leaflet'
import { latLngBounds } from 'leaflet'
import { MapMarker } from 'components/Map/components/MapMarker'
import { MapProps } from 'components/Map/Map'

interface MapMarkersProps extends Pick<MapProps, 'markers'> {}

export const MapMarkers = ({ markers }: MapMarkersProps) => {
  const map = useMap()

  if (markers?.length) {
    map.fitBounds(latLngBounds(markers.map(({ coords }) => coords)).pad(0.05), {
      animate: true,
      maxZoom: 14,
    })
  }

  return (
    <>
      {markers?.map((marker, index) => (
        <MapMarker
          key={`${marker.coords.toString()}-${index}`}
          {...marker}
        />
      ))}
    </>
  )
}
